import React from 'react';
import styled from 'styled-components';
import SquareCheckoutForm from './SquareCheckoutForm';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  color: #333;
  position: relative;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;

  &:hover {
    color: #333;
  }
`;

const ArtworkPreview = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
`;

const ArtworkImage = styled.img`
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
  margin-right: 15px;
`;

const ArtworkInfo = styled.div`
  flex: 1;
`;

const ArtworkTitle = styled.h3`
  margin: 0 0 5px 0;
  font-size: 1.1rem;
`;

const ArtworkDetails = styled.div`
  color: #666;
  font-size: 0.9rem;
  margin-bottom: 5px;
`;

const ArtworkPrice = styled.div`
  font-weight: bold;
  font-size: 1.2rem;
  color: #2c7d46;
`;

const PaymentModal = ({ artwork, onClose, onSuccess }) => {
  // Get the artwork title - items use 'name', collections use 'title'
  const artworkTitle = artwork.title || artwork.name || 'Untitled';

  // Debug: Log artwork data
  console.log('🎨 PaymentModal received artwork:', artwork);
  console.log('🎨 Artwork properties:', {
    id: artwork?.id,
    collectionId: artwork?.collectionId,
    name: artwork?.name,
    title: artwork?.title,
    artworkTitle: artworkTitle,
    price: artwork?.price
  });

  // Get the image path from the artwork
  const getImageSrc = () => {
    const folder = artwork.folder || (artwork.collection ? artwork.collection.folder : '');
    if (!folder) return '';

    return `/images/collections/${folder}/${artwork.imagePath}`;
  };

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={onClose}>&times;</CloseButton>

        <ArtworkPreview>
          {artwork.imagePath && (
            <ArtworkImage
              src={getImageSrc()}
              alt={artworkTitle}
            />
          )}
          <ArtworkInfo>
            <ArtworkTitle>{artworkTitle}</ArtworkTitle>
            <ArtworkDetails>
              {artwork.medium && <div>{artwork.medium}</div>}
              {artwork.size && <div>{artwork.size}</div>}
              {artwork.year && <div>{artwork.year}</div>}
            </ArtworkDetails>
            {artwork.price && (
              <ArtworkPrice>${artwork.price}</ArtworkPrice>
            )}
          </ArtworkInfo>
        </ArtworkPreview>

        <SquareCheckoutForm
          amount={artwork.price}
          artworkTitle={artworkTitle}
          artworkDetails={artwork}
          onSuccess={onSuccess}
          onCancel={onClose}
        />
      </ModalContent>
    </ModalOverlay>
  );
};

export default PaymentModal;